
import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Calendar, Loader2 } from 'lucide-react';
import { EventFilterBarProps } from '../types/calendar';

export const EventFilterBar: React.FC<EventFilterBarProps> = ({
  naturalLanguageInput,
  setNaturalLanguageInput,
  handleNaturalLanguageInput,
  isProcessing = false
}) => {
  return (
    <div className="relative">
      {/* Enhanced Filter Bar with Gradient Background */}
      <div className="relative rounded-xl bg-gradient-to-r from-card via-background to-muted/30 border border-border/50 shadow-md backdrop-blur-sm overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-primary/5 via-transparent to-accent/5" />
        <div className="relative p-4">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-3 flex-1">
              <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10 border border-primary/20">
                <Calendar className="h-5 w-5 text-primary" />
              </div>
              <div className="flex-1 relative">
                <Input
                  placeholder="Ask AI to create events: 'Schedule a meeting with John tomorrow at 2 PM'"
                  value={naturalLanguageInput}
                  onChange={(e) => setNaturalLanguageInput(e.target.value)}
                  onKeyPress={handleNaturalLanguageInput}
                  disabled={isProcessing}
                  className={`
                    flex-1 transition-all duration-200 
                    bg-background/50 backdrop-blur-sm
                    border-border/50 hover:border-primary/30 focus:border-primary/50
                    hover:shadow-md focus:shadow-lg
                    placeholder:text-muted-foreground/70
                    ${isProcessing ? 'pr-10' : ''}
                  `}
                />
                {isProcessing && (
                  <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                    <Loader2 className="h-4 w-4 animate-spin text-primary" />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
